const Analytics = ({ active }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke={active ? "#fff" : 'var(--sidebarColor)'} strokeWidth={1.5} stroke-linecap="round" stroke-linejoin="round" className="size-6">
            <path d="M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z" />
            <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
        </svg>
    )
}

export default Analytics
